import React, { useEffect, useState } from 'react';
import './preFacComponent.css';
import MySelect from '../MySelect/MySelect';
import { fetchClientCodes, fetchClientByCode } from '../../services/api';
import PreFacShipmentSelector from '../PreFacShipmentSelector/PreFacShipmentSelector';

export default function PreFacComponent({ searchParams, applyFilters, removeFilters, onRefresh }) {
  const [clientCodes, setClientCodes] = useState([]);
  const [clientValue, setClientValue] = useState('');
  const [month, setMonth] = useState('');
  const [period, setPeriod] = useState('');
  const [showShipmentSelector, setShowShipmentSelector] = useState(false);
  const [error, setError] = useState('');

  const months = [
    'janvier',
    'février',
    'mars',
    'avril',
    'mai',
    'juin',
    'juillet',
    'août',
    'septembre',
    'octobre',
    'novembre',
    'décembre',
  ];

  const getMonthNames = () => {
    let list = [];
    const formatter = new Intl.DateTimeFormat('fr', { month: 'long' });
    list.push('');
    let today = new Date();
    for (let i = 0; i < 3; i++) {
      const monthIndex = (today.getMonth() - i + 12) % 12;
      const monthName = formatter.format(new Date(today.getYear(), monthIndex, 1));
      list.push(monthName);
    }
    list.push('TOUS');

    return list;
  };

  const month_list = getMonthNames();

  const formatDate = date => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  };

  const getDatesFromMonthPeriod = (month_name, period) => {
    let today = new Date();
    let first_day;
    let last_day;
    const month = months.indexOf(month_name);
    if (today.getMonth() >= month) {
      if (period !== '16 au 31') {
        first_day = new Date(today.getFullYear(), month, 1);
        if (period === '1 au 15') {
          last_day = new Date(today.getFullYear(), month, 15);
        } else {
          if (month !== 11) {
            last_day = new Date(today.getFullYear(), month + 1, 0);
          } else {
            last_day = new Date(today.getFullYear() + 1, 0, 0);
          }
        }
      } else {
        first_day = new Date(today.getFullYear(), month, 16);
        if (month !== 11) {
          last_day = new Date(today.getFullYear(), month + 1, 0);
        } else {
          last_day = new Date(today.getFullYear() + 1, 0, 0);
        }
      }
    } else {
      if (period !== '16 au 31') {
        first_day = new Date(today.getFullYear() - 1, month, 1);
        if (period === '1 au 15') {
          last_day = new Date(today.getFullYear() - 1, month, 15);
        } else {
          if (month !== 11) {
            last_day = new Date(today.getFullYear() - 1, month + 1, 0);
          } else {
            last_day = new Date(today.getFullYear(), 0, 0);
          }
        }
      } else {
        first_day = new Date(today.getFullYear() - 1, month, 16);
        last_day = new Date(today.getFullYear() - 1, month + 1, 0);
      }
    }
    const first_day_str = formatDate(first_day);
    const last_day_str = formatDate(last_day);
    return [first_day_str, last_day_str];
  };

  useEffect(() => {
    const fetchCodes = async () => {
      try {
        let fetchedClientCodes = await fetchClientCodes();
        fetchedClientCodes = fetchedClientCodes.map(client => client.client_code);
        setClientCodes(fetchedClientCodes);
      } catch (error) {
        console.error('Erreur lors de la récupération des codes clients:', error);
      }
    };

    const client_searched = searchParams.get('client_exact');
    const deliveryDateGte = searchParams.get('delivery_date_gte');
    const deliveryDateLte = searchParams.get('delivery_date_lte');

    if (client_searched) {
      setClientValue(client_searched);
    }
    if (deliveryDateGte && deliveryDateLte) {
      let [year, month, day] = deliveryDateGte.split('-').map(Number);
      const first_date = new Date(year, month - 1, day);
      [year, month, day] = deliveryDateLte.split('-').map(Number);
      const last_date = new Date(year, month - 1, day);
      if (first_date.getDate() === 1) {
        if (last_date.getDate() === 15) {
          setPeriod('1 au 15');
        } else {
          setPeriod('1 au 31');
        }
      } else {
        setPeriod('16 au 31');
      }
      setMonth(months[first_date.getMonth()]);
    }

    fetchCodes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClientChange = e => {
    setClientValue(e.target.value);
    if (e.target.value !== '') {
      applyFilters(['client_exact', e.target.value]);
    } else {
      removeFilters(['client_exact'], ['delivery_date_gte'], ['delivery_date_lte']);
      setMonth('');
      setPeriod('');
    }
  };

  const handleMonthChange = async e => {
    const checkPeriod = async client_code => {
      const fetchedClient = await fetchClientByCode(client_code);
      return fetchedClient.period;
    };

    setMonth(e.target.value);
    let newPeriod = '';
    if (e.target.value !== 'TOUS' && e.target.value !== '') {
      if (clientValue) {
        const client_period = await checkPeriod(clientValue);
        if (client_period) {
          switch (client_period) {
            case 'MOIS':
              newPeriod = '1 au 31';
              break;
            case 'QUINZAINE':
              newPeriod = '1 au 15';
              // FETCH INVOICES AND SET PERIOD CONSIDERING WHATS ALREADY BEEN INVOICED !!!!
              break;
            default:
              newPeriod = '1 au 31';
          }
        }
      }
      setPeriod(newPeriod);
      const [first_day_str, last_day_str] = getDatesFromMonthPeriod(e.target.value, newPeriod);
      applyFilters(['delivery_date_gte', first_day_str], ['delivery_date_lte', last_day_str]);
    } else {
      removeFilters(['delivery_date_gte'], ['delivery_date_lte']);
      setPeriod(newPeriod);
    }
  };

  const handlePeriodChange = e => {
    setPeriod(e.target.value);

    if (e.target.value !== '') {
      const [first_day_str, last_day_str] = getDatesFromMonthPeriod(month, e.target.value);
      applyFilters(['delivery_date_gte', first_day_str], ['delivery_date_lte', last_day_str]);
    } else {
      removeFilters(['delivery_date_gte'], ['delivery_date_lte']);
    }
  };

  const handleShowShipmentSelector = () => {
    if (clientValue && month !== '') {
      setShowShipmentSelector(true);
    } else {
      setError('Le nom du client et le mois doivent être renseignés');
    }
  };

  return (
    <form className="table-sub-heading-component">
      <div className="table-sub-heading-component input-group">
        <h3>Code client:</h3>
        {/* <AutoCompleteInput 
                    value={clientValue} 
                    onChange={(value) => handleClientChange({ target: { name: 'client', value } })} 
                    code_list={clientCodes}
                    code_type={'client_code'}
                /> */}
        <MySelect
          values={clientCodes}
          isCreatable={false}
          value={clientValue ? { value: clientValue, label: clientValue } : null}
          onChange={selectedOption =>
            handleClientChange({
              target: { name: 'client', value: selectedOption ? selectedOption.value : '' },
            })
          }
          validationType="str"
        />
      </div>
      <div className="table-sub-heading-component input-group">
        <h3>Mois:</h3>
        <select value={month} onChange={handleMonthChange} disabled={!clientValue}>
          {month_list.map((month, index) => (
            <option key={index} value={month}>
              {month}
            </option>
          ))}
        </select>
      </div>
      <div className="table-sub-heading-component input-group">
        <h3>Période:</h3>
        <select
          value={period}
          onChange={handlePeriodChange}
          disabled={!clientValue || month === 'TOUS'}
        >
          <option key={0} value="1 au 15">
            1 au 15
          </option>
          <option key={1} value="16 au 31">
            16 au 31
          </option>
          <option key={2} value="1 au 31">
            1 au 31
          </option>
          <option key={3} value=""></option>
        </select>
      </div>
      <button
        type="button"
        className="table-sub-heading-component edit-button"
        onClick={handleShowShipmentSelector}
      >
        Éditer facture
      </button>
      {error !== '' && <p className="error">{error}</p>}

      {showShipmentSelector && (
        <PreFacShipmentSelector
          clientValue={clientValue}
          period={period}
          month={month}
          shipment_filters={searchParams}
          onClose={() => setShowShipmentSelector(false)}
          onCancel={() => setShowShipmentSelector(false)}
          onConfirm={() => {
            setShowShipmentSelector(false);
            if (onRefresh) onRefresh();
          }}
        />
      )}
    </form>
  );
}
